import React from 'react';

const WhyChooseUs = () => {
  const features = [
    {
      title: 'Expertise',
      description: 'We combine <b>deep expertise in health policy and technology innovation</b> to deliver solutions that are both strategic and actionable. Our team includes professionals with extensive experience across state and federal health programs, healthcare systems, and emerging technologies—bringing a unique blend of policy knowledge, technical skill, and real-world execution to every engagement.',
    },
    {
      title: 'Tailored Solutions',
      description: 'We understand that each organization’s goals and challenges are distinct. That’s why we deliver <b>tailored solutions</b>, customized strategies, frameworks, and systems designed to meet your specific needs, whether you’re shaping policy, implementing programs, or building intelligent digital infrastructure.',
    },
    {
      title: 'Insightful Analysis',
      description: 'Our work is grounded in <b>insightful analysis</b>. Leveraging our policy, regulatory, and market expertise—along with advanced capabilities in AI, data engineering, and software development—we provide the clarity leaders need to make informed, forward-looking decisions.',
    },
    {
      title: 'Client-Centered Approach',
      description: 'Above all, we take a <b>client-centered approach</b>. We view every engagement as a partnership, focused on collaboration, transparency, and long-term value. Our clients trust us not only for the depth of our expertise but for our commitment to their success—and our shared goal of creating lasting, measurable impact.',
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-accent mb-6">
            Why Choose Onyx Rose Advisors?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl font-bold mx-auto">
            Expertise. Insight. Innovation. Client Partnership.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 lg:p-10 rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-700 leading-relaxed text-lg" dangerouslySetInnerHTML={{ __html: feature.description }}>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
